import React, { useParams } from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { CollapseBlock } from '../../../../../common/index.jsx';
import FormTextField from '../../../../../antd/form/FormTextField/FormTextField.jsx';
import { required } from '../../../../../antd/form/FormValidation.js';
import FormItem from 'antd/es/form/FormItem';
import Form from '../../../../../antd/form/Form/Form.jsx';
import FormButton from '../../../../../antd/form/FormButton/FormButton.jsx';
import FormButtonsContainer from '../../../../../antd/form/FormButtonsContainer/FormButtonsContainer.jsx';
import FormTextEditor from '../../../../../antd/form/FormTextEditor/FormTextEditor.jsx';
import { FIJ_INTEREST_STATUS } from '../../../../../../utils/constants/enums.js';
import FormTextArea from '../../../../../antd/form/FormTextArea/FormTextArea.jsx';

const FijInterestForm = ({
  onSubmit,
  initialValues,
  mode,
  isFriInternalJobsLecturer,
}) => {
  const { t } = useTranslation();

  return (
    <>
      <Form onFinish={onSubmit} initialValues={initialValues}>
        <FormItem>
          <FormTextField
            label={t('Kontaktná e-mail adresa')}
            name="mail"
            rules={[required(t)]}
          />

          <FormTextArea
            label={t('Motivačný text')}
            name="motivation_text"
            style={{ height: '150px' }}
            extra={t(
              'Sem môžete napísať niečo o sebe a dôvod, prečo máte záujem o túto FRI prax (voliteľné).',
            )}
          />
        </FormItem>

        <div>
          <FormButtonsContainer>
            {mode &&
              mode === 'edit' &&
              !isFriInternalJobsLecturer &&
              initialValues.status === FIJ_INTEREST_STATUS.WAITING &&
              !initialValues.archived && (
                <FormButton submitOnClick={true} submitKey={'interest'}>
                  {t('Uložiť')}
                </FormButton>
              )}
            {mode !== 'edit' && !isFriInternalJobsLecturer && (
              <FormButton submitOnClick={true} submitKey={'interest'}>
                {t('Uložiť')}
              </FormButton>
            )}
          </FormButtonsContainer>
        </div>
      </Form>
    </>
  );
};

FijInterestForm.prototype = {
  initialValues: PropTypes.any,
  onSubmit: PropTypes.func,
  mode: PropTypes.string,
  isTeacher: PropTypes.bool,
};

export default FijInterestForm;
